import React from 'react';
import clsx from 'clsx';

export const IconButton = React.forwardRef<
  HTMLButtonElement,
  {
    onClick: (...args: any) => void;
    label: string;
    extraClass?: string;
    children?: any;
    disabled?: boolean;
  }
>(({ onClick, label, extraClass = '', children, disabled = false }, ref) => {
  return (
    <button
      onClick={(e) => onClick(e, ref)}
      ref={ref}
      className={clsx('space-x-2 btn btn-default', extraClass)}
      data-testid='icon-button'
      disabled={disabled}
    >
      {children}
      <span className='text-primary-500'>{label}</span>
    </button>
  );
});
